// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"UP","innerTile":"VP","heading":"WP","instaTileBtn":"XP","disabled":"YP","instaTileElement":"ZP","instagramPic":"_P"};